import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function ReloadIcon({ timeout = 60 }) {
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      let step = (100 * 150) / (timeout * 1000);
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + step
      );
    }, 150);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        size={20}
        thickness={8}
        variant="determinate"
        value={progress}
      />
    </Box>
  );
}
